import React from 'react';
import { useTranslation } from 'react-i18next';

const GoogleMap = () => {
  const { t } = useTranslation();

  return (
    <section id="location" className="map-section" style={{ width: "100%", height: "400px" }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d723.3077083720696!2d16.493653899999998!3d43.518378899999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13355f34830c8585%3A0xa1b59fbf5ed3042d!2sPickleball%20Split%20klub%20Zizi!5e0!3m2!1shr!2shr!4v1753627343879!5m2!1shr!2shr"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={t('googleMap.title')}
      ></iframe>
    </section>
  );
};

export default GoogleMap;
